export interface MixpanelSessionReplayOptions {
  sampleRate: number;
  unmaskTextSelectors: Array<string>;
  blockSelector: string;
}

export interface MixpanelTransportOptions {
  token: string;
  apiHost: string;
  instanceName: string;
  sessionReplay?: MixpanelSessionReplayOptions;
  disablePersistence?: boolean;
  apiTransport?: 'XHR' | 'sendBeacon';
  disableMarketingProperties?: boolean;
}

export const MIXPANEL_DEVICE_ID_PREFIX = '$device:';

export const PERSISTED_REFERRER_PROPERTIES = ['$initial_referrer', '$initial_referring_domain'] as const;

export const LOCKED_MIXPANEL_CONFIG = {
  autocapture: false,
  track_pageview: false,
  record_sessions_percent: 0,
  property_blacklist: ['$current_url', '$referrer', ...PERSISTED_REFERRER_PROPERTIES],
  save_referrer: false,
  ip: true,
  persistence: 'localStorage' as const,
  secure_cookie: true,
  batch_requests: false,
};

export const NO_MARKETING_PROPERTIES_CONFIG = {
  track_marketing: false,
  store_google: false,
  skip_first_touch_marketing: true,
  property_blacklist: [...LOCKED_MIXPANEL_CONFIG.property_blacklist, '$referring_domain', '$search_engine', 'mp_keyword'],
};

export const LOCKED_SESSION_REPLAY_CONFIG = {
  record_mask_all_text: true,
  record_mask_all_inputs: true,
  record_console: false,
  record_network: false,
  record_canvas: false,
  record_collect_fonts: false,
  record_inline_images: false,
};
